


















































import Vue from 'vue'
export default Vue.extend({
  name: 'card-content-base',
  props: {
    item: { type: Object, required: true },
    small: { type: Boolean },
    hover: { type: Boolean },
  },
})
